import { BaseBlock } from "./BaseBlock";

export class ListTitleBlock extends BaseBlock {

    private root!: HTMLElement;

    public override mount(): void {

        this.root =
            document.createElement("div");

        this.root.className =
            "sticker-card account-card list-title-card";

        this.root.innerHTML = `
            <h2>
                Перелік пройдених та доступних кроків
            </h2>
        `;

    }

    public override update(): void {
        // Ничего обновлять не нужно
    }

    public override unmount(): void {
        // Ничего освобождать не нужно
    }

    public getRoot(): HTMLElement {

        return this.root;

    }

}